import type { Router } from 'vue-router'
import { home } from '@/network'
import { useMenuStore } from '@/store/menuStore'
import addDynamicRoutes from '@/utils/addRoutes'

interface MenuItem {
  id?: string
  Id?: string
  name?: string
  IsButton?: boolean
  Func?: string
  meta?: { title?: string }
  children?: MenuItem[]
  Children?: MenuItem[]
  [key: string]: any
}

interface TokenInfoResponse {
  response?: {
    uID?: string
  }
}

interface PermissionResponse {
  response?: MenuItem[] | { children?: MenuItem[]; Children?: MenuItem[] }
}

const extractMenusFromPermissionResponse = (res: PermissionResponse): MenuItem[] => {
  const responseData = res?.response
  if (!responseData) return []
  if (Array.isArray(responseData)) return responseData
  if (Array.isArray(responseData.children)) return responseData.children
  if (Array.isArray(responseData.Children)) return responseData.Children
  return []
}

const collectButtonPermissions = (menus: MenuItem[]) => {
  const buttonPermissions: string[] = []

  const walk = (list: MenuItem[]) => {
    list.forEach((menu) => {
      if (menu.IsButton) {
        const permissionName = menu.Func || menu.name || menu.meta?.title
        if (permissionName) buttonPermissions.push(permissionName)
      }

      const children = Array.isArray(menu.children) ? menu.children : menu.Children
      if (Array.isArray(children) && children.length > 0) {
        walk(children)
      }
    })
  }

  walk(menus)
  return buttonPermissions
}

export const refreshCurrentUserMenus = async (router: Router) => {
  const token = sessionStorage.getItem('wuyetoken') || localStorage.getItem('wuyetoken')
  if (!token) {
    return []
  }

  const tokenData = await home.GetInfoByToken({ token }) as TokenInfoResponse
  const uid = tokenData?.response?.uID
  if (!uid) {
    return []
  }

  const permissionRes = await home.GetUserPermission(
    { uid },
    { suppressBusinessErrorMessage: true }
  ) as PermissionResponse
  const menusData = extractMenusFromPermissionResponse(permissionRes)
  const menuStore = useMenuStore()

  localStorage.setItem('wuyemenusJSON', JSON.stringify(menusData))
  localStorage.setItem('buttonPermissions', JSON.stringify(collectButtonPermissions(menusData)))
  localStorage.setItem('menuPermissionSyncedAt', String(Date.now()))

  if (menusData.length > 0) {
    menuStore.setMenus(menusData)
    addDynamicRoutes(router, menusData)
  } else {
    menuStore.clearMenus()
  }

  return menusData
}

export default refreshCurrentUserMenus
